<template>
    <div class="radio-outer">
        <div class="radio-wrapper">
            <template v-for="(option, index) in options">
                <input
                    :id="'customRadio' + index.toString()"
                    :key="index"
                    v-model="data"
                    type="radio"
                    :name="name"
                    style="display:none;"
                    :value="option.value"
                    @change="onChange()"
                />
                <label :key="index + 'test'" :for="'customRadio' + index">
                    {{ option.label }}
                </label>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OpenSelect',
    props: {
        name: String,
        selected: String,
        options: Array,
    },
    data: () => ({
        data: '',
    }),
    methods: {
        onChange() {
            this.$emit('input', this.data);
        },
    },
    watch: {
        selected(newVal) {
            this.data = newVal;
        },
    },
    mounted() {
        this.data = this.selected;
    },
};
</script>

<style>
.radio-outer {
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
}
.radio-wrapper {
    background-color: rgba(0, 0, 0, 0.4);
    display: grid;
    grid-column-gap: 1px;
    grid-template-columns: auto;
    grid-auto-flow: column;
    text-align: center;
    width: 101%; /* @From Alf: Hack, my screen showed extra right border on the last element. 101% fixed it */
}
@media only screen and (max-width: 600px) {
    .radio-outer {
        margin-bottom: 15px;
    }
    .radio-wrapper {
        grid-auto-flow: row;
    }
}
label {
    background-color: white;
    padding: 8px;
    margin: 0;
    height: 100%;
    box-sizing: border-box;
    cursor: pointer;
}
.radio-outer input[type='radio']:checked + label {
    background-color: var(--primary);
    color: white;
}
</style>
